// extracted by mini-css-extract-plugin
module.exports = {"button":"LastUpdate_button__Be_Qv"};